import React from "react";
import { ChangeEvent, Fragment, MouseEvent } from "react";
import { Link, Prompt } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";

import { apiGet, apiPatch, apiPost } from "../../Api";
import { formatName, TIMEZONES, TZ } from "../../Utilities";
import { IAuthProps } from "../AuthContext";
import withAuth from "../withAuth";
import withTitle from "../withTitle";

// import HasRight from "../HasRight";
// import Indicator from "../Indicator";
import OverflowMenuItem from "../OverflowMenuItem";
import TagListInput from "../TagListInput";
import ToolbarMenuItem from "../ToolbarMenuItem";
import ViewToolbar from "../ViewToolbar";

import "../../blocks.css";
// import "../../icomoon.css";
// import "../../indicator.css";
// import "../../list.css";
import "../../spinner.css";
// import "../../table.css";
import "../../user.css";
import "../viewer.css";
import Indicator from "../Indicator";
import Checkbox from "../Checkbox";


interface IUserDetailsState {
    error?: string;
    isLoading: boolean;
    user?: any;

    baseEmployee?: any;

    roles: any[];
    roleOptions: any[];

    username: string;
    displayName: string;

    timezone: string;

    canSetPassword: boolean;
    initialPassword?: string;
    passwordConfirm?: string;

    mustChangePassword: boolean;

    isSubmitting: boolean;
    hasChanged: boolean;
    submitError?: string;

    [name: string]: any;
}


class UserDetailsView extends React.Component<RouteComponentPropsHistory<any, any> & IAuthProps, IUserDetailsState> {
    constructor(props: Readonly<RouteComponentPropsHistory<any, any> & IAuthProps>) {
        super(props);

        this.state = {
            isLoading: true,

            roleOptions: [],
            roles: [],

            displayName: "",
            username: "",

            timezone: "America/New_York",

            canSetPassword: true,
            mustChangePassword: false,

            hasChanged: false,
            isSubmitting: false,
        };

        this.populateRoles = this.populateRoles.bind(this);
        this.handleRolesChange = this.handleRolesChange.bind(this);
        this.submitChanges = this.submitChanges.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.enablePasswordChange = this.enablePasswordChange.bind(this);
        this.handleDisable = this.handleDisable.bind(this);
        this.handleEnable = this.handleEnable.bind(this);
    }

    public async componentDidMount() {
        const userId = (this.props.match && this.props.match.params.id);

        try {
            if (userId) {
                // Load existing user
                const user = await apiGet<any>(`users/${userId}`);

                this.setState({
                    isLoading: false,
                    user,

                    roles: user.roles,

                    displayName: user.displayName,
                    username: user.username,

                    timezone: user.timezone,

                    canSetPassword: false,

                    mustChangePassword: user.mustChangePassword
                });
            }
            else {
                if (this.props.location.state && this.props.location.state.employee) {
                    const baseEmployee = this.props.location.state.employee;
                    this.setState({
                        baseEmployee,

                        displayName: formatName(baseEmployee.name),
                        username: `${baseEmployee.name.first.substr(0, 1)}${baseEmployee.name.last}`.toLowerCase(),

                        timezone: TZ(),

                        isLoading: false,
                    });
                }
                else {
                    this.setState({
                        error: "Users must be created from an employee record",
                        isLoading: false
                    });
                }
            }

            const roles = await apiGet<any[]>("roles");

            this.setState({
                roleOptions: roles
            });
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="viewer-root">
                    <div className="spinner-center lds-dual-ring-big" />
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className="viewer-root">
                    <span className="error-text">{this.state.error}</span>
                </div>
            );
        }

        return (
            <div className="viewer-root with-actionbar">
                <ViewToolbar>
                    <OverflowMenuItem>
                        <ToolbarMenuItem condition={this.state.user && this.state.user.status === 1 && this.state.user.username !== this.props.authContext.user.username} right="user:write">
                            <button type="button" onClick={this.handleDisable}><i className="icon-ban" /><span>Disable Account</span></button>
                        </ToolbarMenuItem>
                        <ToolbarMenuItem condition={this.state.user && this.state.user.status !== 1} right="user:write">
                            <button type="button" onClick={this.handleEnable}><i className="icon-check" /><span>Enable Account</span></button>
                        </ToolbarMenuItem>
                    </OverflowMenuItem>
                </ViewToolbar>
                <Prompt when={this.state.hasChanged} message="Your changes will not be saved if you continue." />
                <div className="column-root">
                    <section className="info-block">
                        <header>
                            <h3>User Details</h3>
                        </header>
                        <div>
                            <div className="user-avatar avatar-big-responsive float-right">{this.UserNameAvatar(this.state.displayName)}</div>
                            <dl className="info-list block-split-spring">
                                <dt>Username</dt>
                                <dd>
                                    <input type="text" className="input-light" name="username" value={this.state.username} onChange={this.handleInputChanged} />
                                </dd>

                                <dt>Display Name</dt>
                                <dd>
                                    <input type="text" className="input-light" name="displayName" value={this.state.displayName} onChange={this.handleInputChanged} />
                                </dd>

                                <dt>Timezone</dt>
                                <dd>
                                    <select className="input-light" name="timezone" value={this.state.timezone} onChange={this.handleInputChanged}>
                                        {TIMEZONES.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                                    </select>
                                </dd>

                                {
                                    this.state.user ?
                                        <Fragment>
                                            <dt>Bound To Employee</dt>
                                            <dd>
                                                {
                                                    this.state.user.employeeId
                                                        ? (<Fragment><span>Yes. </span><Link to={`/employees/${this.state.user.employeeId}`}>View</Link></Fragment>)
                                                        : (<span>No</span>)
                                                }
                                            </dd>

                                            <dt>Account Status</dt>
                                            <dd>
                                                {this.statusToIndicator(this.state.user.status)}
                                            </dd>
                                        </Fragment>
                                        : ""
                                }
                                {
                                    this.state.canSetPassword ?
                                        <Fragment>
                                            <dt>Password</dt>
                                            <dd>
                                                <input type="password" className="input-light" name="initialPassword" value={this.state.initialPassword} onChange={this.handleInputChanged} />
                                            </dd>

                                            <dt>Confirm Password</dt>
                                            <dd>
                                                <input type="password" className="input-light" name="passwordConfirm" value={this.state.passwordConfirm} onChange={this.handleInputChanged} />
                                            </dd>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <dt>Password</dt>
                                            {/* eslint-disable-next-line */ /* Complains about href not being a navigatable path */}
                                            <dd><a href="#" role="button" onClick={this.enablePasswordChange}>Change password</a></dd>
                                        </Fragment>
                                }
                                <dt />
                                <dd><Checkbox fancy={true} id="mustChangePassword" name="mustChangePassword" checked={this.state.mustChangePassword} onChange={this.handleInputChanged}>User must change password on next login</Checkbox></dd>

                                <dt>Roles</dt>
                                <dd>
                                    <TagListInput items={this.state.roles} displayMember="name" requestOptions={this.populateRoles} onItemsChange={this.handleRolesChange} />
                                </dd>

                                <dt>Effective Permissions</dt>
                                <dd>
                                    {this.GeneratePermissionList(this.state.roles)}
                                </dd>
                            </dl>
                        </div>
                    </section>
                </div>
                &nbsp;
                {this.state.submitError ? <span className="error-text">{this.state.submitError}</span> : ""}
                <div className="action-panel">
                    <button className="button blue btn-confirm push-right" disabled={this.state.isSubmitting} onClick={this.submitChanges}>Save</button>
                    <button className="button blue btn-cancel" disabled={this.state.isSubmitting} onClick={this.cancelChanges}>Cancel</button>
                </div>
            </div>
        );
    }

    private handleRolesChange(items: any[]) {
        this.setState({
            hasChanged: true,
            roles: items
        });
    }

    private enablePasswordChange(e: MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();

        this.setState({ canSetPassword: true });
    }

    private async submitChanges() {
        try {
            if (this.state.user) {
                // Update existing user
                this.setState({
                    isSubmitting: true,
                    submitError: undefined
                });

                const update: { displayName: string, username: string, roles: any[], initialPassword?: string, timezone?: string, mustChangePassword?: boolean } = {
                    displayName: this.state.displayName,
                    username: this.state.username,

                    timezone: this.state.timezone,

                    roles: this.state.roles,

                    mustChangePassword: this.state.mustChangePassword
                };

                if (this.state.canSetPassword) {
                    if (!this.state.initialPassword || this.state.initialPassword === "" || this.state.initialPassword !== this.state.passwordConfirm) {
                        this.setState({
                            isSubmitting: false,
                            submitError: "Passwords do not match"
                        });
                        return;
                    }

                    update.initialPassword = this.state.initialPassword;
                }

                await apiPatch(`users/${this.state.user.id}`, update);

                this.setState({
                    hasChanged: false,
                    isSubmitting: false,
                });
            }
            else {
                // Create new user
                if (!this.state.initialPassword || this.state.initialPassword === "" || this.state.initialPassword !== this.state.passwordConfirm) {
                    this.setState({
                        isSubmitting: false,
                        submitError: "Passwords do not match"
                    });
                    return;
                }

                const userInfo = {
                    displayName: this.state.displayName,
                    username: this.state.username,

                    timezone: this.state.timezone,

                    linkedEmployeeId: this.state.baseEmployee ? this.state.baseEmployee.id : undefined,

                    initialPassword: this.state.initialPassword,

                    roles: this.state.roles,

                    mustChangePassword: this.state.mustChangePassword
                };

                this.setState({
                    isSubmitting: true,
                    submitError: undefined
                });

                await apiPost("users", userInfo);

                this.setState({
                    hasChanged: false,
                    isSubmitting: false,
                });
            }
            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                isSubmitting: false,
                submitError: e.statusCode === 409 ? "Username already exists" : e.message
            });
        }
    }

    private cancelChanges() {
        this.props.history.goBack();
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) {
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            hasChanged: true,
            [name]: value
        })
    }

    private statusToIndicator(status: number) {
        let text = "";
        let color = "";
        let icon = "";
        switch (status) {
            case 0:
                text = "Disabled";
                color = "red";
                icon = "times";
                break;
            case 1:
                text = "Enabled";
                color = "green";
                icon = "check";
                break;
            case 2:
                text = "Suspended";
                color = "yellow";
                icon = "times";
                break;
            default: break;
        }

        return <Indicator color={color} icon={icon} text={text} />;
    }

    private populateRoles(search: string) {
        search = search.toLowerCase();
        return this.state.roleOptions.filter((a: any) => (a.name as string).toLowerCase().includes(search));
    }

    private GeneratePermissionList(roles: any[]) {
        const permMap = this.parseRights(this.computeEffectivePermissions(roles)) as { [right: string]: string[] };
        const keys = Object.keys(permMap).sort((a, b) => permMap[a].length - permMap[b].length);
        if (keys.length === 0) {
            return <span>None</span>;
        }

        return (
            <ul className="tag-list-small-blocks">
                {keys.map((p: any) => (
                    <li key={p}>
                        <header className="tag-text">{this.RightToText(p)}</header>
                        <div className="tag-list-inner">
                            {
                                permMap[p].sort((a, b) => a.localeCompare(b)).map((r: string) => <span key={r} className={`tag tag-${this.subRightToClass(r)}`}>{this.subRightToString(p, r)}</span>)
                        }
                        </div>
                    </li>
                ))}
            </ul>
        );
    }

    private parseRights(permissions: any) {
        if (!permissions) {
            return {};
        }

        const map: { [right: string]: string[] } = {};
        for (const right of permissions) {
            const parts = right.split(":");
            if (!map[parts[0]]) {
                map[parts[0]] = [];
            }

            map[parts[0]].push(parts.slice(1).join(":"));
        }

        return map;
    }

    private RightToText(right: string) {
        switch (right) {
            case "fair": return "Fairs";
            case "survey": return "Surveys";
            case "user": return "Users";
            case "role": return "Roles";
            case "appt": return "Appointments";
            case "location": return "Locations";
            case "employee": return "Employee";
            case "device": return "External Devices";
            case "surgery": return "Surgeries";
            case "auditlog": return "Audit Log";
            case "tasks": return "Task List";
            case "bonus": return "Bonuses";
            case "sched": return "Schedule";
            case "files": return "Files";
            case "acct": return "Accounting";
            case "metrics": return "Metrics";
            default: return right;
        }
    }

    private subRightToString(right: string, sub: string) {
        switch (right) {
            case "surgery":
                switch (sub) {
                    case "admin": return "Edit Surgery Types";
                    case "create:marketer": return "Set Marketer";
                    case "create:full": return "Create Full";
                    case "write:admin": return "Edit After Finalize";
                    case "note:marketing": return "View/Add Marketing Note";
                    case "note:post": return "Add Post Note";
                    case "note:pre": return "Add Pre Note";
                    case "note:contact": return "View/Add Contact Note";
                    case "note:ins": return "View/Add Insurance Note";
                    case "note:upload": return "Attach Files To Notes";
                    case "delete:note": return "Delete Notes";
                    case "summary": return "Summarize";
                    case "report": return "View OR Log Book";
                    case "yourcases": return "View Your Cases";
                    case "read:m": return "View Marketer";
                    case "read:ins": return "View Insurance Info";
                    case "write:ins": return "Edit Insurance Info";
                    case "history": return "View History";
                    case "s:reset": return "Reset Status";
                    case "cancel": return "Cancel Surgery";
                    case "contact": return "View/Update Contact Outreach";
                    case "review": return "View/Update Review Info";
                    case "doc:read": return "View Documents";
                    case "doc:upload": return "Upload Documents";
                    case "doc:delete": return "Delete Documents";
                    default: break;
                }
                break;
            case "tasks":
                switch (sub) {
                    case "read:all": return "View Other User's Tasks";
                    default: break;
                }
                break;
            case "acct":
                switch (sub) {
                    case "recpt:read": return "View Receipts";
                    case "ins:read": return "View Insurance Companies";
                    case "ins:create": return "Create Insurance Companies";
                    case "ins:write": return "Edit Insurance Companies";
                    case "ins:delete": return "Delete Insurance Companies";
                    default: break;
                }
                break;
            case "bonus":
                switch (sub) {
                    case "own:read": return "See Own Bonus";
                    default: break;
                }
                break;
            case "survey":
                switch (sub) {
                    case "t:admin": return "Edit Survey Types";
                    case "t:s": return "View Survey Types";
                    case "contact": return "View/Update Outreach Info";
                    default: break;
                }
                break;
            case "fair":
                switch (sub) {
                    case "read:emails": return "View Fair Email List";
                    case "write:admin": return "Edit After Scheduled Time";
                    case "p:s:read": return "View Social Media Photos";
                    case "p:s:upload": return "Upload Social Media Photos";
                    case "p:s:delete": return "Delete Social Media Photos";
                    case "p:r:read": return "View Receipt Photos";
                    case "p:r:upload": return "Upload Receipt Photos";
                    case "p:r:delete": return "Delete Receipt Photos";
                    case "contact": return "View/Update Outreach Info";
                    default: break;
                }
                break;
            case "appt":
                switch (sub) {
                    case "stats:read": return "View Stats";
                    case "readall": return "View All";
                    case "read:ins": return "View Insurance Info";
                    case "note:ins": return "View/Add Insurance Note";
                    case "delete:note": return "Delete Note";
                    case "contact": return "View/Update Outreach Info";
                    case "create:bare": return "Create Without Survey";
                    case "create:delegated": return "Change Assigned Person";
                    case "con:read": return "View Pellet Consult";
                    case "con:write": return "Edit Pellet Consult";
                    case "con:delete": return "Delete Pellet Consult";
                    default: break;
                }
                break;
            case "metrics":
                switch (sub) {
                    case "bonus:d:calc": return "Calculate Dr Bonuses";
                    case "bonus:d:read": return "View Dr Bonuses";
                    case "bonus:m:calc": return "Calculate Marketer Bonuses";
                    case "bonus:m:read": return "View Marketer Bonuses";
                    case "bonus:n:calc": return "Calculate Provider Bonuses";
                    case "bonus:n:read": return "View Provider Bonuses";
                    case "bonus:so:calc": return "Calculate Surgical Outcomes Bonuses";
                    case "bonus:so:read": return "View Surgical Outcomes Bonuses";
                    case "bonus:mm:calc": return "Calculate Marketing Manager Bonuses";
                    case "bonus:mm:read": return "View Marketing Manager Bonuses";
                    case "prov:read": return "View Provider Stats";
                    case "prov:write": return "Edit Non-calculated Provider Stats";
                    case "loc:read": return "View Location Stats";
                    case "mark:read": return "View Marketer Stats";
                    case "cs:read": return "View Case Stats Sheet";
                    case "cs:write": return "Edit Case Stats Settings";
                    case "t:s": return "View Survey Types";
                    case "contact": return "View/Update Outreach Info";
                    default: break;
                }
                break;
            case "sched":
                switch (sub) {
                    case "read": return "View Own Schedule";
                    case "prov:read": return "View Provider's Schedule";
                    case "prov:write": return "Edit Provider's Schedule";
                    case "prov:s": return "Summarize Provider's Schedule";
                    case "off:read": return "View Office Schedule";
                    case "off:write": return "Edit Office Schedule";
                    case "off:s": return "Summarize Office Schedule";
                    case "co:read": return "View Clinical Outcomes Schedule";
                    case "co:write": return "Edit Clinical Outcomes Schedule";
                    case "mv:read": return "View Marketer Vacation Schedule";
                    case "mv:write": return "Edit Marketer Vacation Schedule";
                    case "mv:s": return "Summarize Marketer Vacation Schedule";
                    default: break;
                }
                break;
            default:
                break;
        }

        switch (sub) {
            case "read": return "View";
            case "write": return "Edit";
            case "create": return "Create";
            case "delete": return "Delete";
            case "admin": return "Admin";
            case "upload": return "Upload";
            case "summary": return "View Summary";
            default: break;
        }

        return sub;
    }

    private subRightToClass(right: string) {
        const parts = right.split(/:/g);

        for (const item of parts) {
            switch (item) {
                case "read":
                case "create":
                case "write":
                case "delete":
                case "admin":
                case "summary":
                    return item;
                case "calc":
                case "upload":
                    return "create";
                default:
                    break;
            }
        }

        return "default";
    }

    private computeEffectivePermissions(roles: any[]) {
        if (!roles) {
            return [];
        }

        const permMap: { [perm: string]: boolean } = {};

        for (const role of roles) {
            for (const permission of role.permissions) {
                permMap[permission] = true;
            }
        }

        return Object.keys(permMap);
    }

    private UserNameAvatar(name: string) {
        if (name === "") {
            return "";
        }

        const parts = name.split(" ");
        let text = parts[0][0].toUpperCase();
        if (parts.length >= 2 && parts[1].length > 0) {
            text += parts[1][0].toUpperCase();
        }

        return text;
    }

    private async handleDisable() {
        await this.setUserState(0);
    }

    private async handleEnable() {
        await this.setUserState(1);
    }

    private async setUserState(status: number) {
        if (!this.state.user) {
            return;
        }

        try {
            this.setState({
                error: undefined,
                isSubmitting: true
            });

            await apiPost(`users/${this.state.user.id}/status`, { status });

            this.setState({
                isSubmitting: false
            });

            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                error: e.message
            });
        }
    }
}

export default withTitle("User Details", withAuth(UserDetailsView));
